import React from "react";

import SearchFilterToggleV2 from "./FiltersV2/SearchFilterToggleV2";
import SearchTagFilterTrigger from "./SearchTagFilterTrigger";
import type { SearchTagFilterTriggerProps } from "./types";

type SearchFilterTriggerSelectorProps = SearchTagFilterTriggerProps & {
  isTagsDrawerVisible: boolean;
  isFiltersV2: boolean;
};

const SearchFilterTriggerSelector = ({ isTagsDrawerVisible, isFiltersV2, ...triggerProps }: SearchFilterTriggerSelectorProps) =>
  isFiltersV2 ? <SearchFilterToggleV2 {...triggerProps} isTagsDrawerVisible={isTagsDrawerVisible} /> : <SearchTagFilterTrigger {...triggerProps} />;

export default React.memo(SearchFilterTriggerSelector);
